<div class="visual" [innerHtml]="body()"></div>
